function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFragments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3570.2844,
    y1: 4062.3845,
    x2: 1126.5291,
    y2: 1027.3937
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_1_)"
    },
    d: "M2897.992,2865.494c-56.132,59.094-109.244,97.202-151.206,127.311 c-493.261,353.92-1076.919,250.754-1200.964,225.56c-183.174-37.204-537.245-109.117-793.232-410.153 c-387.287-455.442-326.981-1172.977-26.575-1646.633c54.949-86.64,345.205-567.51,935.15-644.626 c357.028-46.67,773.209,47.458,1074.595,299.96C3368.398,1346.937,3323.361,2417.679,2897.992,2865.494z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163781985692864140380000011726606533440001195_",
    gradientUnits: "userSpaceOnUse",
    x1: -1764.6042,
    y1: -1921.7366,
    x2: -1341.099,
    y2: -1835.351,
    gradientTransform: "matrix(0.9999 0.0143 -0.0143 0.9999 2377.3684 3191.0476)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163781985692864140380000011726606533440001195_)"
    },
    d: "M943.582,665.763 c-7.155-17.109-19.761-28.604-34.073-31.131c-14.312-2.526-28.73,4.202-39.021,18.225 c-377.523,514.422-173.591,1077.142-83.497,1270.666c8.047,17.285,21.735,28.097,36.736,29.042 c15.001,0.944,29.479-8.098,38.871-24.283C1185.443,1371.945,1019.46,847.196,943.582,665.763z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.56
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M889.491,710.684c-16.551,97.427-29.328,195.606-40.002,293.903 c-10.533,98.333-18.746,196.913-24.03,295.637l-3.363,74.066c-0.978,24.692-1.294,49.405-1.974,74.103l-0.855,37.05 l0.011,37.055l0.01,37.051c0.094,12.348-0.218,24.703,0.296,37.042c1.597,98.785,8.034,197.378,18.993,295.375l0.03,0.262 c0.527,4.705-2.862,8.947-7.568,9.473c-4.706,0.527-8.948-2.862-9.473-7.567c-0.007-0.058-0.017-0.157-0.021-0.216 l-6.404-74.202l-1.6-18.546l-0.771-9.274l-0.449-9.293l-1.797-37.168l-1.822-37.16l-0.925-18.578l-0.327-18.593l-1.307-74.362 c-0.384-12.393,0.059-24.783,0.096-37.175l0.384-37.171l0.384-37.168l1.252-37.142c0.944-24.756,1.524-49.527,2.767-74.265 l4.158-74.189c6.479-98.851,15-197.549,26.329-295.935c5.705-49.186,11.873-98.317,18.822-147.342l5.192-36.77l5.536-36.723 c3.752-24.48,7.686-48.907,11.963-73.341c0.313-1.787,2.014-2.982,3.802-2.669c1.781,0.312,2.974,2.004,2.673,3.785 L889.491,710.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M840.623,1006.867c-0.694-0.497-1.213-1.237-1.419-2.13c-0.443-1.943,0.77-3.88,2.716-4.326 c52.038-11.893,127.004-113.923,127.754-114.952c1.17-1.604,3.41-1.959,5.019-0.808c0.008,0.006,0.017,0.012,0.026,0.018 c1.612,1.176,1.964,3.435,0.789,5.045c-3.133,4.291-77.334,105.248-131.977,117.738 C842.48,1007.689,841.434,1007.448,840.623,1006.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M840.626,1006.869c-0.158-0.113-0.31-0.239-0.452-0.38 c-2.397-2.393-59.024-59.285-81.649-120.656c-0.691-1.869,0.267-3.946,2.139-4.634c1.872-0.689,3.954,0.268,4.635,2.139 c22.068,59.853,79.4,117.462,79.978,118.037c1.411,1.409,1.413,3.695,0.004,5.106 C844.014,1007.751,842.039,1007.881,840.626,1006.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M819.773,1274.61c-0.531-0.38-0.967-0.909-1.234-1.56c-0.759-1.84,0.119-3.952,1.965-4.712 c81.131-33.436,141.794-129.117,142.398-130.081c1.057-1.689,3.284-2.201,4.976-1.142c1.668,1.086,2.199,3.288,1.142,4.976 c-0.616,0.981-62.468,98.595-145.768,132.923C822.059,1275.505,820.75,1275.309,819.773,1274.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M795.054,1261.906c-26.342-18.86-69.549-58.504-99.361-130.167 c-0.764-1.839,0.107-3.952,1.948-4.719c1.839-0.765,3.949,0.104,4.719,1.948c43.549,104.689,118.044,140.132,118.79,140.483 c1.814,0.852,2.597,2.987,1.758,4.793c-0.835,1.809-2.982,2.596-4.793,1.759 C817.071,1275.519,808.143,1271.278,795.054,1261.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M811.313,1640.425c-0.031-0.022-0.063-0.045-0.094-0.068 c-0.828-0.636-83.519-64.435-130.143-156.222c-0.903-1.779-0.192-3.953,1.582-4.856c1.779-0.903,3.948-0.196,4.856,1.582 c45.859,90.282,127.274,153.131,128.092,153.757c1.583,1.211,1.886,3.476,0.673,5.061 C815.093,1641.232,812.89,1641.554,811.313,1640.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M811.307,1640.421c-0.436-0.312-0.808-0.726-1.078-1.231c-0.941-1.757-0.277-3.944,1.481-4.884 c0.905-0.484,91.189-49.555,147.683-147.965c0.993-1.726,3.198-2.323,4.93-1.331c1.696,1.01,2.321,3.201,1.331,4.929 c-57.564,100.268-149.616,150.241-150.543,150.735C813.86,1641.343,812.391,1641.197,811.307,1640.421z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135665302027758038430000012011646748911524540_",
    gradientUnits: "userSpaceOnUse",
    x1: -407.2193,
    y1: -3302.3057,
    x2: -424.6659,
    y2: -2447.3948,
    gradientTransform: "matrix(0.9592 -0.2827 0.2827 0.9592 1828.2324 3909.1904)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135665302027758038430000012011646748911524540_)"
    },
    d: "M572.566,887.936 c-9.847-11.764-22.624-17.756-34.551-16.245c-11.927,1.512-21.669,10.362-26.363,23.964 c-172.198,498.972,126.848,893.592,245.463,1024.414c10.594,11.684,24.059,16.873,36.143,13.942 c12.084-2.931,21.306-13.624,24.76-28.714C936.74,1386.61,676.985,1012.689,572.566,887.936z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.56
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M541.233,936.672c10.809,81.008,24.826,161.7,40.546,241.955 c15.842,80.25,33.539,160.133,53.655,239.388l15.559,59.314c5.3,19.738,11.127,39.329,16.664,58.998l8.435,29.465l9.12,29.255 l9.118,29.251c3.111,9.727,5.902,19.559,9.342,29.175c25.539,77.603,54.886,153.844,87.651,228.479l0.105,0.241 c1.904,4.335-0.069,9.393-4.404,11.297c-4.336,1.904-9.394-0.068-11.298-4.405c-0.027-0.061-0.068-0.16-0.094-0.223 l-23.18-57.132l-5.793-14.279l-2.874-7.147l-2.624-7.241l-10.494-28.957l-10.515-28.942l-5.271-14.465l-4.801-14.622 l-19.203-58.478c-3.331-9.705-6.007-19.611-9.006-29.417l-8.778-29.483l-8.776-29.479l-8.084-29.671 c-5.301-19.803-10.893-39.528-15.954-59.389l-14.836-59.666c-19.013-79.731-36.45-159.817-51.548-240.353 c-7.52-40.271-14.661-80.612-21.159-121.06c-6.665-40.427-12.741-80.915-18.025-121.603c-0.233-1.799,1.035-3.447,2.834-3.68 c1.799-0.234,3.447,1.035,3.68,2.834L541.233,936.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M573.357,1182.735c-0.349-0.275-0.654-0.618-0.89-1.024c-1.001-1.726-0.41-3.936,1.311-4.936 c38.004-22.035,72.15-120.804,72.492-121.796c0.647-1.887,2.696-2.894,4.583-2.247c1.894,0.644,2.894,2.696,2.247,4.583 c-1.425,4.169-35.384,102.331-75.697,125.708C576.083,1183.787,574.484,1183.623,573.357,1182.735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M521.128,1148.369c-14.631-11.522-29.707-25.378-41.498-40.762 c-1.213-1.583-0.914-3.848,0.669-5.061c1.58-1.215,3.845-0.934,5.061,0.669c32.047,41.8,91.314,73.174,91.911,73.487 c1.733,0.938,2.443,3.109,1.518,4.876c-0.927,1.765-3.109,2.443-4.876,1.519 C572.316,1182.257,547.448,1169.095,521.128,1148.369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M622.514,1399.391c-0.196-0.155-0.384-0.333-0.548-0.535c-1.272-1.536-1.058-3.813,0.475-5.083 c55.79-46.205,80.185-136.449,80.423-137.356c0.514-1.929,2.486-3.077,4.414-2.568c1.936,0.515,3.078,2.491,2.568,4.415 c-1.005,3.79-25.244,93.403-82.801,141.071C625.714,1400.439,623.821,1400.42,622.514,1399.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M531.924,1358.043c-13.661-10.758-27.811-24.127-41.652-40.726 c-1.276-1.53-1.07-3.809,0.46-5.086c1.531-1.277,3.825-1.045,5.086,0.46c31.237,37.465,64.342,57.669,86.602,68.027 c24.144,11.226,41.123,13.616,41.291,13.637c1.976,0.277,3.361,2.086,3.096,4.058c-0.265,1.977-2.078,3.363-4.053,3.1 C620.532,1401.218,579.168,1395.247,531.924,1358.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M597.94,1628.781c-11.241-8.852-22.363-18.656-32.819-29.422 c-1.388-1.429-1.356-3.715,0.076-5.105c1.43-1.387,3.703-1.374,5.106,0.076c58.246,59.99,137.86,89.643,138.653,89.935 c1.89,0.689,2.834,2.761,2.147,4.63c-0.686,1.874-2.761,2.834-4.63,2.147C705.803,1690.798,650.602,1670.252,597.94,1628.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M705.482,1690.493c-0.105-0.083-0.209-0.173-0.303-0.27c-1.419-1.4-1.435-3.688-0.035-5.107 c0.594-0.6,59.78-61.386,80.252-152.799c0.436-1.945,2.368-3.166,4.315-2.732c1.939,0.427,3.169,2.365,2.732,4.315 c-20.941,93.502-81.552,155.675-82.161,156.295C708.978,1691.513,706.906,1691.614,705.482,1690.493z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093858983377007033280000002367194191243010215_",
    gradientUnits: "userSpaceOnUse",
    x1: 1127.6531,
    y1: 494.3536,
    x2: 1121.7419,
    y2: 3232.2678
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093858983377007033280000002367194191243010215_)"
    },
    d: "M1778.511,2542.782v96.72l-0.141,0.006 c-5.929,58.376-250.091,165.588-604.722,167.57c-521.43,2.914-697.523-113.525-705.717-173.146h-0.195v-89.122 L1778.511,2542.782z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062907359194429879100000011054236456955729829_",
    gradientUnits: "userSpaceOnUse",
    x1: 1159.5924,
    y1: 1379.5681,
    x2: 1070.8929,
    y2: 4212.1079
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062907359194429879100000011054236456955729829_)"
    },
    d: "M467.737,2545.169 c0,60.123,300.86,107.598,665.987,106.064c358.662-1.507,644.787-49.896,644.787-108.104 c0-58.208-286.125-105.707-644.787-106.097C768.597,2436.635,467.737,2485.047,467.737,2545.169z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090980192290896084140000005779761693613194167_",
    gradientUnits: "userSpaceOnUse",
    x1: -3646.6011,
    y1: 2735.0752,
    x2: -3651.1184,
    y2: 2504.697,
    gradientTransform: "matrix(-1 0.0219 0 1 -2524.9526 -26.6952)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090980192290896084140000005779761693613194167_)"
    },
    d: "M472.815,2537.853 c0,59.671,298.562,106.889,660.991,105.488c356.107-1.377,640.262-49.333,640.262-107.133 c0-57.8-284.155-105.037-640.262-105.513C771.378,2430.209,472.815,2478.182,472.815,2537.853z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122715091964543853740000016168266001995629193_",
    gradientUnits: "userSpaceOnUse",
    x1: 1127.6531,
    y1: 494.3484,
    x2: 1121.7419,
    y2: 3232.2729
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000122715091964543853740000016168266001995629193_)"
    },
    points: "467.737,2633.932  467.737,2544.811 1778.511,2542.782 1778.511,2639.502  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085958579528938050710000000950802560454273960_",
    gradientUnits: "userSpaceOnUse",
    x1: 1159.5924,
    y1: 1379.5681,
    x2: 1070.8929,
    y2: 4212.1079
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085958579528938050710000000950802560454273960_)"
    },
    d: "M467.737,2545.169 c0,60.123,300.86,107.598,665.987,106.064c358.662-1.507,644.787-49.896,644.787-108.104 c0-58.208-286.125-105.707-644.787-106.097C768.597,2436.635,467.737,2485.047,467.737,2545.169z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136399380453385315040000015119093181870434740_",
    gradientUnits: "userSpaceOnUse",
    x1: 1127.2573,
    y1: 494.3523,
    x2: 1121.3462,
    y2: 3232.2656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136399380453385315040000015119093181870434740_)"
    },
    d: "M1778.511,2359.47v96.72l-0.141,0.006 c-5.929,58.376-250.09,160.507-604.722,158.683c-561.967-2.889-697.523-104.638-705.717-164.259h-0.195V2361.5L1778.511,2359.47 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049901691040594295850000016819221937555641223_",
    gradientUnits: "userSpaceOnUse",
    x1: 1153.8577,
    y1: 1379.387,
    x2: 1065.1583,
    y2: 4211.9272
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049901691040594295850000016819221937555641223_)"
    },
    d: "M467.737,2361.858 c0,60.123,300.86,107.597,665.987,106.064c358.662-1.507,644.787-49.896,644.787-108.104s-286.125-105.707-644.787-106.097 C768.597,2253.324,467.737,2301.736,467.737,2361.858z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026868306613882337400000018278209780594631076_",
    gradientUnits: "userSpaceOnUse",
    x1: -3646.6011,
    y1: 2551.7637,
    x2: -3651.1184,
    y2: 2321.3857,
    gradientTransform: "matrix(-1 0.0219 0 1 -2524.9526 -26.6952)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026868306613882337400000018278209780594631076_)"
    },
    d: "M472.815,2354.542 c0,59.671,298.562,106.889,660.991,105.488c356.107-1.377,640.262-49.333,640.262-107.133 c0-57.8-284.155-105.036-640.262-105.513C771.378,2246.897,472.815,2294.87,472.815,2354.542z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147942061104322529980000018406836754864728199_",
    gradientUnits: "userSpaceOnUse",
    x1: 1127.2573,
    y1: 494.3494,
    x2: 1121.3462,
    y2: 3232.2739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000147942061104322529980000018406836754864728199_)"
    },
    points: "467.737,2450.621  467.737,2361.5 1778.511,2359.47 1778.511,2456.19  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127020896701331364940000010240073190262591880_",
    gradientUnits: "userSpaceOnUse",
    x1: 1153.8577,
    y1: 1379.387,
    x2: 1065.1583,
    y2: 4211.9272
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127020896701331364940000010240073190262591880_)"
    },
    d: "M467.737,2361.858 c0,60.123,300.86,107.597,665.987,106.064c358.662-1.507,644.787-49.896,644.787-108.104s-286.125-105.707-644.787-106.097 C768.597,2253.324,467.737,2301.736,467.737,2361.858z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043434635033201520050000006580315603859125170_",
    gradientUnits: "userSpaceOnUse",
    x1: 1126.8606,
    y1: 494.352,
    x2: 1120.9495,
    y2: 3232.2654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043434635033201520050000006580315603859125170_)"
    },
    d: "M1778.511,2175.708v96.719 l-0.141,0.006c-5.929,58.376-250.09,160.507-604.722,158.684c-561.967-2.889-697.523-104.639-705.717-164.259h-0.195v-89.122 L1778.511,2175.708z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165955425029026405260000003898352475530099095_",
    gradientUnits: "userSpaceOnUse",
    x1: 1148.1089,
    y1: 1379.2078,
    x2: 1059.4095,
    y2: 4211.7461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165955425029026405260000003898352475530099095_)"
    },
    d: "M467.737,2178.096 c0,60.122,300.86,107.597,665.987,106.063c358.662-1.507,644.787-49.896,644.787-108.104 c0-58.208-286.125-105.707-644.787-106.097C768.597,2069.562,467.737,2117.973,467.737,2178.096z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036929993346011079670000012893327711015896463_",
    gradientUnits: "userSpaceOnUse",
    x1: -3646.6011,
    y1: 2368.0012,
    x2: -3651.1184,
    y2: 2137.6233,
    gradientTransform: "matrix(-1 0.0219 0 1 -2524.9526 -26.6952)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036929993346011079670000012893327711015896463_)"
    },
    d: "M472.815,2170.779 c0,59.671,298.562,106.889,660.991,105.488c356.107-1.377,640.262-49.332,640.262-107.133 c0-57.8-284.155-105.036-640.262-105.513C771.378,2063.135,472.815,2111.108,472.815,2170.779z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056392619406144843540000002622259484982187182_",
    gradientUnits: "userSpaceOnUse",
    x1: 1126.8606,
    y1: 494.3438,
    x2: 1120.9495,
    y2: 3232.2637
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000056392619406144843540000002622259484982187182_)"
    },
    points: "467.737,2266.859  467.737,2177.737 1778.511,2175.708 1778.511,2272.428  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157992214826661180770000012300762613857132460_",
    gradientUnits: "userSpaceOnUse",
    x1: 1148.1089,
    y1: 1379.2078,
    x2: 1059.4095,
    y2: 4211.7461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157992214826661180770000012300762613857132460_)"
    },
    d: "M467.737,2178.096 c0,60.122,300.86,107.597,665.987,106.063c358.662-1.507,644.787-49.896,644.787-108.104 c0-58.208-286.125-105.707-644.787-106.097C768.597,2069.562,467.737,2117.973,467.737,2178.096z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088817095528346329670000017044764877364945027_",
    gradientUnits: "userSpaceOnUse",
    x1: 1126.4639,
    y1: 494.3486,
    x2: 1120.5527,
    y2: 3232.262
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088817095528346329670000017044764877364945027_)"
    },
    d: "M1778.511,1991.946v96.719 l-0.141,0.006c-5.929,58.376-250.09,160.507-604.722,158.684c-561.967-2.889-697.523-104.638-705.717-164.259h-0.195v-89.122 L1778.511,1991.946z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079468885136391651140000001428503291156651949_",
    gradientUnits: "userSpaceOnUse",
    x1: 1142.3601,
    y1: 1379.028,
    x2: 1053.6608,
    y2: 4211.5654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079468885136391651140000001428503291156651949_)"
    },
    d: "M467.737,1994.333 c0,60.122,300.86,107.597,665.987,106.063c358.662-1.506,644.787-49.896,644.787-108.104s-286.125-105.706-644.787-106.097 C768.597,1885.8,467.737,1934.211,467.737,1994.333z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161621794547172190420000014923621390947327670_",
    gradientUnits: "userSpaceOnUse",
    x1: -3646.6013,
    y1: 2184.239,
    x2: -3651.1184,
    y2: 1953.8608,
    gradientTransform: "matrix(-1 0.0219 0 1 -2524.9526 -26.6952)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161621794547172190420000014923621390947327670_)"
    },
    d: "M472.815,1987.017 c0,59.671,298.562,106.89,660.991,105.487c356.107-1.377,640.262-49.332,640.262-107.132s-284.155-105.037-640.262-105.514 C771.378,1879.373,472.815,1927.346,472.815,1987.017z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047052685608014911750000008740306965371247024_",
    gradientUnits: "userSpaceOnUse",
    x1: 1126.4639,
    y1: 494.3474,
    x2: 1120.5527,
    y2: 3232.2673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000047052685608014911750000008740306965371247024_)"
    },
    points: "467.737,2083.097  467.737,1993.975 1778.511,1991.946 1778.511,2088.666  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157282213795534684770000009105428062400533402_",
    gradientUnits: "userSpaceOnUse",
    x1: 1142.3601,
    y1: 1379.028,
    x2: 1053.6608,
    y2: 4211.5654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157282213795534684770000009105428062400533402_)"
    },
    d: "M467.737,1994.333 c0,60.122,300.86,107.597,665.987,106.063c358.662-1.506,644.787-49.896,644.787-108.104s-286.125-105.706-644.787-106.097 C768.597,1885.8,467.737,1934.211,467.737,1994.333z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102542648607384746420000015124968270379842741_",
    gradientUnits: "userSpaceOnUse",
    x1: 1126.0671,
    y1: 494.3477,
    x2: 1120.156,
    y2: 3232.261
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102542648607384746420000015124968270379842741_)"
    },
    d: "M1778.511,1808.184v96.719 l-0.141,0.007c-5.929,58.376-250.09,160.507-604.722,158.683c-561.967-2.89-697.523-104.639-705.717-164.259h-0.195v-89.122 L1778.511,1808.184z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144315428911208510460000009093425817728683703_",
    gradientUnits: "userSpaceOnUse",
    x1: 1136.6115,
    y1: 1378.8463,
    x2: 1047.9121,
    y2: 4211.3813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144315428911208510460000009093425817728683703_)"
    },
    d: "M467.737,1810.571 c0,60.123,300.86,107.597,665.987,106.063c358.662-1.506,644.787-49.896,644.787-108.104 c0-58.209-286.125-105.707-644.787-106.097C768.597,1702.037,467.737,1750.449,467.737,1810.571z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175315339498761395120000014123981684214193816_",
    gradientUnits: "userSpaceOnUse",
    x1: -3646.6011,
    y1: 2000.4769,
    x2: -3651.1184,
    y2: 1770.099,
    gradientTransform: "matrix(-1 0.0219 0 1 -2524.9526 -26.6952)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175315339498761395120000014123981684214193816_)"
    },
    d: "M472.815,1803.255 c0,59.671,298.562,106.89,660.991,105.488c356.107-1.378,640.262-49.333,640.262-107.133 c0-57.8-284.155-105.036-640.262-105.513C771.378,1695.611,472.815,1743.583,472.815,1803.255z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016039869435632451690000002473767678993700785_",
    gradientUnits: "userSpaceOnUse",
    x1: 1126.067,
    y1: 494.351,
    x2: 1120.156,
    y2: 3232.271
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000016039869435632451690000002473767678993700785_)"
    },
    points: "467.737,1899.334  467.737,1810.213 1778.511,1808.184 1778.511,1904.903  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163758382755116173390000010418063149187909266_",
    gradientUnits: "userSpaceOnUse",
    x1: 1136.6115,
    y1: 1378.8463,
    x2: 1047.9121,
    y2: 4211.3813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163758382755116173390000010418063149187909266_)"
    },
    d: "M467.737,1810.571 c0,60.123,300.86,107.597,665.987,106.063c358.662-1.506,644.787-49.896,644.787-108.104 c0-58.209-286.125-105.707-644.787-106.097C768.597,1702.037,467.737,1750.449,467.737,1810.571z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072259534354194710540000010449819656900928411_",
    gradientUnits: "userSpaceOnUse",
    x1: 1125.6703,
    y1: 494.3468,
    x2: 1119.7593,
    y2: 3232.2603
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072259534354194710540000010449819656900928411_)"
    },
    d: "M1778.511,1624.421v96.72l-0.141,0.006 c-5.929,58.376-250.09,160.507-604.722,158.683c-561.967-2.889-697.523-104.638-705.717-164.259h-0.195v-89.122 L1778.511,1624.421z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151523083821760470670000016934044647909888933_",
    gradientUnits: "userSpaceOnUse",
    x1: 1130.8625,
    y1: 1378.6672,
    x2: 1042.1631,
    y2: 4211.2075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151523083821760470670000016934044647909888933_)"
    },
    d: "M467.737,1626.809 c0,60.123,300.86,107.598,665.987,106.064c358.662-1.507,644.787-49.896,644.787-108.104 c0-58.209-286.125-105.707-644.787-106.097C768.597,1518.275,467.737,1566.687,467.737,1626.809z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046326124088457209840000002786972103052615848_",
    gradientUnits: "userSpaceOnUse",
    x1: -3646.6011,
    y1: 1816.7146,
    x2: -3651.1184,
    y2: 1586.3365,
    gradientTransform: "matrix(-1 0.0219 0 1 -2524.9526 -26.6952)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046326124088457209840000002786972103052615848_)"
    },
    d: "M472.815,1619.493 c0,59.671,298.562,106.889,660.991,105.488c356.107-1.377,640.262-49.333,640.262-107.133 c0-57.8-284.155-105.036-640.262-105.513C771.378,1511.848,472.815,1559.821,472.815,1619.493z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181802726742332183680000014517562035599230358_",
    gradientUnits: "userSpaceOnUse",
    x1: 1125.6703,
    y1: 494.3487,
    x2: 1119.7593,
    y2: 3232.2732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000181802726742332183680000014517562035599230358_)"
    },
    points: "467.737,1715.572  467.737,1626.45 1778.511,1624.421 1778.511,1721.141  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137811557785804444350000018279622324058767494_",
    gradientUnits: "userSpaceOnUse",
    x1: 1130.8625,
    y1: 1378.6672,
    x2: 1042.1631,
    y2: 4211.2075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137811557785804444350000018279622324058767494_)"
    },
    d: "M467.737,1626.809 c0,60.123,300.86,107.598,665.987,106.064c358.662-1.507,644.787-49.896,644.787-108.104 c0-58.209-286.125-105.707-644.787-106.097C768.597,1518.275,467.737,1566.687,467.737,1626.809z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080169280691536206050000017418550508779839128_",
    gradientUnits: "userSpaceOnUse",
    x1: 1125.2736,
    y1: 494.3467,
    x2: 1119.3625,
    y2: 3232.2654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080169280691536206050000017418550508779839128_)"
    },
    d: "M1778.511,1440.659v96.72l-0.141,0.006 c-5.929,58.376-250.09,160.507-604.722,158.684c-561.967-2.89-697.523-104.639-705.717-164.259h-0.195v-89.122 L1778.511,1440.659z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101784384213238311640000016360404905104343972_",
    gradientUnits: "userSpaceOnUse",
    x1: 1125.1138,
    y1: 1378.4872,
    x2: 1036.4144,
    y2: 4211.0273
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101784384213238311640000016360404905104343972_)"
    },
    d: "M467.737,1443.047 c0,60.122,300.86,107.597,665.987,106.063c358.662-1.506,644.787-49.896,644.787-108.104 c0-58.208-286.125-105.707-644.787-106.097C768.597,1334.512,467.737,1382.924,467.737,1443.047z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174592980188229195220000016848337662258979491_",
    gradientUnits: "userSpaceOnUse",
    x1: -3646.6011,
    y1: 1632.9521,
    x2: -3651.1184,
    y2: 1402.5742,
    gradientTransform: "matrix(-1 0.0219 0 1 -2524.9526 -26.6952)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174592980188229195220000016848337662258979491_)"
    },
    d: "M472.815,1435.73 c0,59.671,298.562,106.889,660.991,105.487c356.107-1.377,640.262-49.333,640.262-107.133 c0-57.8-284.155-105.036-640.262-105.513C771.378,1328.086,472.815,1376.059,472.815,1435.73z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003787923296987821390000012933814854093990320_",
    gradientUnits: "userSpaceOnUse",
    x1: 1125.2736,
    y1: 494.3446,
    x2: 1119.3625,
    y2: 3232.269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000003787923296987821390000012933814854093990320_)"
    },
    points: "467.737,1531.809  467.737,1442.688 1778.511,1440.659 1778.511,1537.379  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016763839955323906090000000676727071542576535_",
    gradientUnits: "userSpaceOnUse",
    x1: 1125.1138,
    y1: 1378.4872,
    x2: 1036.4144,
    y2: 4211.0273
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016763839955323906090000000676727071542576535_)"
    },
    d: "M467.737,1443.047 c0,60.122,300.86,107.597,665.987,106.063c358.662-1.506,644.787-49.896,644.787-108.104 c0-58.208-286.125-105.707-644.787-106.097C768.597,1334.512,467.737,1382.924,467.737,1443.047z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073718218920438607830000004623524309267477898_",
    gradientUnits: "userSpaceOnUse",
    x1: 1755.7841,
    y1: 888.2835,
    x2: 3204.2737,
    y2: 888.2835
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AB6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F68E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073718218920438607830000004623524309267477898_)"
    },
    d: "M2915.452,832.285 c-4.96-0.116-8.951-4.121-9.041-9.082c-0.925-50.853-16.787-303.353-239.155-356.119 c-247.566-58.744-360.858,193.017-360.858,193.017s-306.31-117.488-365.054,197.213 c-192.063,46.095-241.963,296.921-117.042,419.484c19.849,19.474,46.453,30.481,74.258,30.731l1202.812,10.835 c35.302,0.318,66.605-22.788,76.635-56.637C3215.578,1134.915,3264.825,840.467,2915.452,832.285z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018199947356722451920000008298304175770309821_",
    gradientUnits: "userSpaceOnUse",
    x1: 3131.2417,
    y1: 866.8996,
    x2: 942.1498,
    y2: 1028.3517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5AB6FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F68E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018199947356722451920000008298304175770309821_)"
    },
    d: "M2887.961,837.68 c-4.951-0.119-8.936-4.112-9.036-9.063c-0.986-48.774-16.692-282.908-226.127-331.988 c-234.091-54.858-341.217,180.247-341.217,180.247s-289.637-109.716-345.184,184.166 c-179.867,42.633-227.875,272.801-114.025,388.406c19.959,20.266,47.14,31.789,75.584,32.042l1132.285,10.073 c35.382,0.315,66.733-22.896,76.689-56.849C3172.242,1114.286,3214.146,845.486,2887.961,837.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053540520579029181170000018337925119959766954_",
    gradientUnits: "userSpaceOnUse",
    x1: -1598.6588,
    y1: 4142.9771,
    x2: -1615.5762,
    y2: 4971.9565,
    gradientTransform: "matrix(-0.9862 -0.166 -0.166 0.9862 1992.7834 -2860.5979)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053540520579029181170000018337925119959766954_)"
    },
    d: "M2819.314,1528.562 c8.117-12.468,19.723-19.719,31.382-19.647c11.658,0.073,22.064,7.464,28.161,20.016 c223.643,460.44-18.522,875.049-117.555,1014.755c-8.845,12.477-21.208,19.035-33.182,17.614 c-11.974-1.421-22.093-10.646-27.167-24.775C2526.509,2050.903,2733.245,1660.779,2819.314,1528.562z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.56
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2861.474,1571.871c-0.371,39.786-1.527,79.472-3.257,119.168 c-1.569,39.696-3.768,79.362-6.34,119.007c-5.203,79.289-12.706,158.416-21.772,237.384l-7.369,59.165 c-2.571,19.708-5.669,39.347-8.478,59.028l-4.345,29.503l-5.033,29.399l-5.035,29.403c-1.749,9.788-3.178,19.635-5.261,29.365 l-11.711,58.527l-2.928,14.635l-3.399,14.537l-6.77,29.084l-6.748,29.094l-1.688,7.275l-1.938,7.214l-3.922,14.419 l-15.699,57.69c-1.194,4.391-5.723,6.982-10.114,5.787c-4.391-1.194-6.982-5.723-5.787-10.115 c0.016-0.062,0.034-0.124,0.053-0.185l0.084-0.279c22.887-75.661,42.296-152.47,57.885-230.151 c2.198-9.657,3.744-19.447,5.61-29.172l5.386-29.22l5.387-29.225l4.703-29.347c3.049-19.579,6.387-39.117,9.2-58.736 l8.099-58.912c10.174-78.64,17.948-157.603,23.894-236.704c5.827-79.092,9.965-158.407,10.978-237.655l0.001-0.05 c0.022-1.744,1.454-3.139,3.197-3.117C2860.101,1568.708,2861.496,1570.128,2861.474,1571.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2853.008,1812.115c-0.942,1.238-2.633,1.726-4.128,1.083 c-41.512-17.828-85.582-108.391-87.438-112.235c-0.836-1.726-0.11-3.8,1.615-4.634c1.727-0.832,3.801-0.11,4.634,1.615 c0.444,0.921,44.792,92.071,83.927,108.882c1.761,0.752,2.575,2.794,1.818,4.555 C2853.322,1811.647,2853.177,1811.894,2853.008,1812.115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2922.382,1746.765c-28.088,36.911-68.22,64.763-70.166,66.106 c-1.579,1.085-3.737,0.686-4.826-0.892c-1.09-1.578-0.7-3.73,0.892-4.826c0.532-0.37,54-37.498,79.983-81.418 c0.988-1.718,3.106-2.196,4.752-1.221c1.651,0.975,2.196,3.101,1.221,4.752 C2930.688,1735.267,2926.674,1741.124,2922.382,1746.765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2830.808,2026.406c-1.085,1.426-3.104,1.802-4.638,0.813 c-60.933-39.218-94.656-122.67-96.062-126.205c-0.71-1.78,0.159-3.801,1.942-4.505c1.778-0.708,3.796,0.159,4.507,1.939 c0.335,0.847,34.333,84.938,93.372,122.936c1.608,1.036,2.074,3.183,1.038,4.796 C2830.916,2026.258,2830.863,2026.333,2830.808,2026.406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2935.973,1949.959c-48.314,63.492-102.945,78.213-105.44,78.856 c-1.855,0.479-3.744-0.635-4.224-2.49c-0.482-1.857,0.642-3.752,2.485-4.228c0.64-0.169,64.405-17.438,113.688-93.465 c1.036-1.575,3.193-2.07,4.798-1.024c1.609,1.042,2.068,3.191,1.024,4.798 C2944.269,1938.631,2940.14,1944.482,2935.973,1949.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2908.942,2212.628l-0.002,0.003c-50.124,65.803-124.702,104.269-125.452,104.652 c-1.705,0.87-3.794,0.191-4.662-1.516c-0.873-1.707-0.187-3.8,1.511-4.666c0.735-0.373,73.944-38.165,123.083-102.674 c1.161-1.526,3.339-1.819,4.865-0.658C2909.809,2208.927,2910.101,2211.105,2908.942,2212.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2784.676,2316.292c-0.014,0.019-0.029,0.037-0.045,0.059c-1.192,1.498-3.375,1.749-4.876,0.555 c-0.658-0.522-66.212-53.352-97.21-140.938c-0.642-1.804,0.305-3.792,2.112-4.426c1.806-0.639,3.786,0.306,4.426,2.112 c30.316,85.641,94.348,137.308,94.993,137.821C2785.555,2312.653,2785.817,2314.793,2784.676,2316.292z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085250304815803816950000004387216376376452241_",
    gradientUnits: "userSpaceOnUse",
    x1: 584.0764,
    y1: 3949.7253,
    x2: 1024.6641,
    y2: 4039.5952,
    gradientTransform: "matrix(-0.8871 -0.4616 -0.4616 0.8871 5503.3486 -770.7906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085250304815803816950000004387216376376452241_)"
    },
    d: "M3169.731,1783.905 c14.994-12.142,32.212-16.453,46.569-11.707c14.356,4.746,24.244,18.022,26.753,35.944 c92.043,657.463-372.367,1072.322-550.365,1205.149c-15.898,11.863-33.771,15.016-47.978,8.48 c-14.208-6.536-23.009-21.96-23.628-41.42C2599.804,2311.468,3010.719,1912.669,3169.731,1783.905z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.56
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M3203.585,1853.853c-8.136,24.492-16.584,48.809-25.224,73.082l-13.045,36.37l-13.383,36.244 c-17.822,48.335-36.411,96.382-55.45,144.251c-38.162,95.71-79.048,190.322-121.883,284.065l-32.793,70.008 c-11.067,23.272-22.756,46.249-34.105,69.391l-17.178,34.64l-17.985,34.235l-17.987,34.237 c-6.079,11.368-11.786,22.938-18.252,34.1l-37.885,67.469l-9.473,16.87l-10.012,16.561l-20.002,33.138l-19.984,33.158 l-4.996,8.291l-5.282,8.113l-10.614,16.198l-42.475,64.807c-2.677,4.084-8.156,5.225-12.239,2.549 c-4.083-2.677-5.224-8.156-2.548-12.24c0.032-0.051,0.066-0.101,0.1-0.15l0.178-0.258 c58.38-84.367,112.91-171.51,163.103-261.215c6.558-11.05,12.367-22.522,18.544-33.787l18.286-33.937l18.288-33.94 l17.493-34.361c11.561-22.96,23.462-45.754,34.745-68.855l33.456-69.508c43.857-93.044,84.966-187.396,123.824-282.671 c38.712-95.31,75.44-191.547,108.342-288.959l0.015-0.046c0.598-1.773,2.52-2.724,4.293-2.126 C3203.227,1850.174,3204.184,1852.081,3203.585,1853.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M3096.257,2147.025c-1.159,0.309-2.443,0.054-3.414-0.793 c-43.888-38.389-62.052-167.458-62.802-172.936c-0.276-2.037,1.159-3.891,3.181-4.193c2.036-0.28,3.914,1.145,4.194,3.181 c0.181,1.314,18.531,131.783,60.328,168.344c1.547,1.356,1.704,3.707,0.352,5.253 C3097.591,2146.458,3096.945,2146.841,3096.257,2147.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M3096.249,2147.027c-1.935,0.516-3.945-0.599-4.525-2.532c-0.586-1.969,0.535-4.044,2.503-4.634 c0.813-0.24,81.755-24.729,131.502-68.676c1.553-1.37,3.895-1.209,5.253,0.325c1.363,1.54,1.216,3.893-0.325,5.252 c-50.992,45.047-133.473,69.989-134.299,70.235C3096.323,2147.007,3096.285,2147.018,3096.249,2147.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2983.267,2402.572c-1.37,0.365-2.889-0.068-3.845-1.239 c-59.358-72.532-67.866-192.448-67.947-193.652c-0.133-2.049,1.414-3.809,3.47-3.958c2.052-0.134,3.825,1.421,3.962,3.469 c0.077,1.179,8.445,118.762,66.278,189.428c1.301,1.59,1.066,3.937-0.525,5.238 C2984.238,2402.204,2983.762,2402.439,2983.267,2402.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M3045.297,2396.403c-1.841,0.491-3.627,0.945-5.368,1.372 c-33.622,8.246-55.404,7.042-56.314,6.988c-2.054-0.125-3.615-1.887-3.49-3.941c0.119-2.048,1.887-3.604,3.937-3.492 c0.857,0.054,86.733,4.204,178.146-70.093c1.587-1.3,3.936-1.058,5.235,0.541c1.299,1.595,1.055,3.94-0.541,5.235 C3120.697,2370.574,3076.135,2388.173,3045.297,2396.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2848.697,2733.211c-23.16,6.181-38.121,8.642-38.518,8.706 c-2.028,0.323-3.936-1.06-4.264-3.091c-0.32-2.029,1.084-3.916,3.091-4.264c1.052-0.172,106.649-17.587,193.199-77.654 c1.68-1.178,4.008-0.757,5.178,0.936c1.173,1.689,0.753,4.009-0.936,5.179 C2951.061,2701.469,2888.046,2722.71,2848.697,2733.211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2810.552,2741.837c-1.5,0.4-3.153-0.171-4.06-1.539c-0.603-0.904-60.268-92.083-63.53-212.319 c-0.053-2.059,1.587-3.768,3.619-3.822c2.054-0.055,3.766,1.565,3.822,3.619c3.206,118.121,61.698,207.514,62.29,208.406 c1.137,1.71,0.67,4.02-1.043,5.158C2811.306,2741.572,2810.932,2741.735,2810.552,2741.837z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054223482087739047180000000633806919127496869_",
    gradientUnits: "userSpaceOnUse",
    x1: 2071.3894,
    y1: 3152.5708,
    x2: 2049.6577,
    y2: 2722.2891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000054223482087739047180000000633806919127496869_)"
    },
    points: "1889.785,2664.087  1853.692,2987.792 2272.443,2987.792 2217.9,2664.087  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026877975430783643120000009088187474052672402_",
    gradientUnits: "userSpaceOnUse",
    x1: 2004.9197,
    y1: 2807.5374,
    x2: 2048.4753,
    y2: 1046.6146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026877975430783643120000009088187474052672402_)"
    },
    d: "M1161.123,1843.411v762.876 c0,62.757,50.01,114.076,112.745,115.695c278.64,7.185,1253.186,24.607,1518.433,20.697 c45.589-0.672,82.52-37.154,83.835-82.729c5.115-177.227,13.421-603.397-17.319-801.251 c-6.474-41.666-41.644-72.823-83.788-74.171c-233.465-7.469-1266.548-31.184-1531.671-25.23 C1197.635,1760.325,1161.123,1797.675,1161.123,1843.411z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044135540335364931790000005762869125322140821_",
    gradientUnits: "userSpaceOnUse",
    x1: 1975.124,
    y1: 1884.7343,
    x2: 2094.0818,
    y2: 2850.6672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044135540335364931790000005762869125322140821_)"
    },
    d: "M1208.992,1839.697v724.785 c0,36.641,29.413,66.497,66.049,67.044l1479.1,18.274c36.323,0.543,66.096-28.68,66.231-65.007l2.474-718.309 c0.097-25.974-20.596-47.256-46.563-47.889l-1514.324-30.593C1232.917,1787.296,1208.992,1810.646,1208.992,1839.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    d: "M2831.51,2679.831c-0.014,0-0.027,0-0.042,0l-1622.516-27.645 c-1.312-0.024-2.359-1.106-2.336-2.418c0.021-1.312,1.092-2.347,2.417-2.337l1622.516,27.645 c1.312,0.024,2.359,1.106,2.336,2.418C2833.864,2678.792,2832.803,2679.831,2831.51,2679.831z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163766937594095741130000004787693197135673260_",
    gradientUnits: "userSpaceOnUse",
    x1: 2064.8811,
    y1: 2893.4395,
    x2: 2108.4382,
    y2: 2190.3113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163766937594095741130000004787693197135673260_)"
    },
    d: "M2362.641,3054.022h-612.87 c-16.65,0-29.153-11.853-25.934-24.585l7.864-31.102c2.365-9.353,12.655-16.22,24.876-16.601l590.829-18.436 c12.768-0.398,24.074,6.379,26.856,16.1l14.177,49.538C2392.123,3041.806,2379.56,3054.022,2362.641,3054.022z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.32,
      fill: "#FFFFFF"
    },
    cx: 2118.314,
    cy: 2207.969,
    r: 241.386
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177480887864122830640000009946723114428569733_",
    gradientUnits: "userSpaceOnUse",
    x1: 1994.1124,
    y1: 2212.1104,
    x2: 2255.1646,
    y2: 2212.1104
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177480887864122830640000009946723114428569733_)"
    },
    d: "M2116.05,2351.019 c-10.572,0-20.404-5.608-25.874-14.829l-91.747-154.672c-8.588-14.476-3.961-33.258,10.332-41.954 c14.286-8.694,32.835-4.013,41.422,10.462l63.689,107.37l84.193-167.486c7.564-15.048,25.745-21.036,40.6-13.375 c14.858,7.661,20.772,26.072,13.207,41.118l-108.916,216.662c-4.98,9.906-14.879,16.296-25.846,16.684 C2116.757,2351.012,2116.403,2351.019,2116.05,2351.019z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052796465366880710830000000118812470126227897_",
    gradientUnits: "userSpaceOnUse",
    x1: 13430.4941,
    y1: 1334.2738,
    x2: 13137.5439,
    y2: 1501.4858,
    gradientTransform: "matrix(1 0 0 1 -11652.5908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052796465366880710830000000118812470126227897_)"
    },
    d: "M1733.365,1606.868 c-0.346-0.132-186.161-325.539-211.27-356.162c-4.225-5.151-10.762-7.774-17.377-6.986l-51.864,6.181l-60.93,131.812 l101.506-59.116c-10.044,69.466,120.355,172.7,165.076,210.37c4.539,3.823,4.911,10.67,0.812,14.961l-17.854,18.69 c29.312,29.711,63.136,48.789,101.31,57.613L1733.365,1606.868z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060712217117994390010000010233697253719701637_",
    gradientUnits: "userSpaceOnUse",
    x1: -3385.5752,
    y1: -2399.5991,
    x2: -3408.064,
    y2: -2054.7725,
    gradientTransform: "matrix(-0.8974 -0.4412 -0.4412 0.8974 -2357.3115 2161.1482)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060712217117994390010000010233697253719701637_)"
    },
    d: "M1651.793,1556.531 c0,0-11.395,3.681-15.253,13.829c-1.845,4.856,0.144,10.355,4.367,13.381c18.763,13.443,80.654,56.842,109.216,65.342 c2.341,0.697,4.569-1.422,4.042-3.807c-1.466-6.634-6.207-19.884-21.48-39.28l1.37,2.772c1.734,3.508-2.086,7.16-5.493,5.237 C1709.457,1603.22,1670.548,1579.618,1651.793,1556.531z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150783956405387484870000005385056872774412444_",
    gradientUnits: "userSpaceOnUse",
    x1: 13402.1543,
    y1: 1375.9753,
    x2: 14404.4844,
    y2: 748.5015,
    gradientTransform: "matrix(1 0 0 1 -11652.5908 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150783956405387484870000005385056872774412444_)"
    },
    d: "M1660.988,1686.734 c-0.311-0.2-28.19-67.368-28.501-67.567c-25.561-155.627-87.926-288.91-106.318-323.981c-3.094-5.899-8.966-9.79-15.604-10.358 l-52.042-4.443l-86.345,116.754l111.37-37.35c-23.895,65.995,82.913,193.484,119.086,239.424 c3.671,4.662,2.65,11.443-2.233,14.816l-21.267,14.69c22.692,35.028,51.955,60.557,87.554,76.924L1660.988,1686.734z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137819570415959158160000005700912550556948409_",
    gradientUnits: "userSpaceOnUse",
    x1: -2222.3413,
    y1: -3762.0872,
    x2: -2244.8284,
    y2: -3417.2856,
    gradientTransform: "matrix(-0.7895 -0.6137 -0.6137 0.7895 -2374.9006 3191.1018)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137819570415959158160000005700912550556948409_)"
    },
    d: "M1591.292,1620.93 c0,0-11.904,1.299-17.736,10.457c-2.79,4.381-1.955,10.17,1.568,13.987c15.655,16.962,67.482,71.989,93.732,86.093 c2.152,1.157,4.762-0.467,4.729-2.91c-0.093-6.794-2.054-20.729-13.087-42.815l0.781,2.992c0.988,3.786-3.491,6.59-6.439,4.016 C1638.314,1678.323,1604.986,1647.334,1591.292,1620.93z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058565791140416395270000009675245147441269427_",
    gradientUnits: "userSpaceOnUse",
    x1: 5137.9653,
    y1: 1393.2944,
    x2: 5427.168,
    y2: 716.1369,
    gradientTransform: "matrix(1 0 0 1 -3820.8906 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058565791140416395270000009675245147441269427_)"
    },
    d: "M1214.923,1255.795 c0,0-47.078,70.023-50.941,101.965c-3.863,31.941,13.018,42.988,62.293,47.061c146.635,12.122,218.92-31.825,218.92-31.825 c10.031-63.956,17.168-80.227,100.944-115.002c0,0-105.962,8.412-127.287,0.137 C1397.527,1249.855,1214.923,1255.795,1214.923,1255.795z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181066262727777216430000001838470832338765967_",
    gradientUnits: "userSpaceOnUse",
    x1: -5958.4736,
    y1: -866.6213,
    x2: -5891.3125,
    y2: -698.1486,
    gradientTransform: "matrix(-0.963 -0.2693 -0.2693 0.963 -4530.4502 12.0256)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181066262727777216430000001838470832338765967_)"
    },
    d: "M1378.187,858.634 c0,0-24.77,4.508-32.186,15.57c-5.95,8.876-30.412,3.394-38.17,21.954c-4.006,9.582-13.574,15.477-23.885,14.228 c-25.679-3.112-67.202-0.937-85.229,40.117c-13.76,31.336-0.585,48.362,15.676,57.527c11.943,6.732,16.976,21.587,10.763,33.807 c-5.96,11.721-6.264,27.113,12.073,44.479c41.093,38.917,113.198-33.317,113.198-33.317l51.71-146.874L1378.187,858.634z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146491872582261351680000004553913738553974964_",
    gradientUnits: "userSpaceOnUse",
    x1: 1393.6737,
    y1: 1052.0985,
    x2: 1697.8381,
    y2: 714.1379
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146491872582261351680000004553913738553974964_)"
    },
    d: "M1342.243,1246.525 c0,0,54.823-52.203,81.809-86.779c14.588-18.69,19.169-43.295,12.422-66.024c-12.321-41.509-34.217-84.501-36.214-91.193 c-3.061-10.256-64.532-9.829-64.532-9.829s-120.963,78.506-168.49,211.49l53.376,16.617c0,0,31.583-52.987,62.79-86.675 c0,0-53.998,71.333-55.9,100.536L1342.243,1246.525z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067216400305946251100000011175993910347255730_",
    gradientUnits: "userSpaceOnUse",
    x1: -4520.9399,
    y1: 1237.8914,
    x2: -4229.1177,
    y2: 1237.8914,
    gradientTransform: "matrix(-1 0 0 1 -3256.1277 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067216400305946251100000011175993910347255730_)"
    },
    d: "M1446.698,1267.125l-41.194-44.819 l-47.575,12.81c0,0-55.465,8.593-87.209,0c-31.745-8.593-31.745-8.593-31.745-8.593l-71.736-22.333l-11.266,31.841 c-2.861,8.085,0.014,17.059,7.004,22.026c6.207,4.41,13.481,9.257,18.118,11.285c9.447,4.133,217.621,1.307,217.621,1.307 L1446.698,1267.125z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047030040715293522250000017240858981958537384_",
    gradientUnits: "userSpaceOnUse",
    x1: -6356.0039,
    y1: 541.8438,
    x2: -6341.3521,
    y2: 434.6537,
    gradientTransform: "matrix(-0.9974 -0.0717 -0.0717 0.9974 -4921.998 105.0094)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047030040715293522250000017240858981958537384_)"
    },
    d: "M1366.414,914.926l-29.753,80.692 c2.728,16.771,44.967,17.243,51.492,7.229c0.664-1.019,1.044-2.198,1.296-3.388l13.373-63.096 c1.061-5.006-1.319-10.11-5.836-12.514l-16.422-8.741C1374.241,911.742,1368.594,908.102,1366.414,914.926z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103264686878015807610000010908135393550301841_",
    gradientUnits: "userSpaceOnUse",
    x1: -4271.8818,
    y1: -2878.0098,
    x2: -4137.5693,
    y2: -3117.0413,
    gradientTransform: "matrix(-0.7128 -0.7014 -0.7014 0.7128 -3677.0078 53.9295)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103264686878015807610000010908135393550301841_)"
    },
    d: "M1449.206,873.738 c0,0,10.121,24.352-2.729,60.961c-12.85,36.609-33.012,39.509-45.617,30.227c-12.605-9.282-28.884-25.777-30.447-59.133 C1368.849,872.436,1435.225,842.919,1449.206,873.738z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050628486793039889870000005128931896719704499_",
    gradientUnits: "userSpaceOnUse",
    x1: -4242.9995,
    y1: -3086.1692,
    x2: -4175.8433,
    y2: -2917.7097,
    gradientTransform: "matrix(-0.7128 -0.7014 -0.7014 0.7128 -3677.0078 53.9295)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050628486793039889870000005128931896719704499_)"
    },
    d: "M1395.303,903.99 c0,0,22.961-49.465,55.844-17.957l2.384,12.854c0,0,31.882-8.578,21.871-37.502c-10.011-28.924-40.764-43.433-74.996-25.285 c-34.232,18.148-53,34.378-51.56,60.595c1.44,26.217,21.202,17.544,21.202,17.544s4.06-19.2,13.333-22.486 c9.272-3.286,8.86,11.286,8.86,11.286L1395.303,903.99z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154394920880545037480000017153339925852039820_",
    gradientUnits: "userSpaceOnUse",
    x1: -4243.291,
    y1: -2861.9473,
    x2: -4108.98,
    y2: -3100.9761,
    gradientTransform: "matrix(-0.7128 -0.7014 -0.7014 0.7128 -3677.0078 53.9295)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154394920880545037480000017153339925852039820_)"
    },
    d: "M1387.65,904.485 c0,0,11.952-25.358-4.25-26.519c-16.202-1.162-9.98,24.467-6.885,33.83L1387.65,904.485z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057107464484416028270000014404421255494327990_",
    gradientUnits: "userSpaceOnUse",
    x1: -3582.667,
    y1: 1779.1077,
    x2: -3204.4814,
    y2: 2012.6178,
    gradientTransform: "matrix(-0.9988 -0.0494 -0.0494 0.9988 -3214.6587 -55.0328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057107464484416028270000014404421255494327990_)"
    },
    d: "M1310.34,1284.864 c0.145,0.007,0.289,0.011,0.436,0.01l189.475-0.206c4.684-0.004,8.477-3.805,8.472-8.489c-0.005-4.686-3.82-8.556-8.491-8.472 l-189.475,0.207c-4.684,0.004-8.477,3.805-8.472,8.489C1302.29,1280.94,1305.859,1284.643,1310.34,1284.864z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141454360201950305900000003174196794976362939_",
    gradientUnits: "userSpaceOnUse",
    x1: -3580.7866,
    y1: 1960.9921,
    x2: -3202.6028,
    y2: 2194.5012,
    gradientTransform: "matrix(-1 0 0 1 -3256.1277 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141454360201950305900000003174196794976362939_)"
    },
    d: "M1670.58,1112.833h-157.796 c-11.641,0-22.236,6.717-27.201,17.246l-72.949,154.684h196.098c7.502,0,14.242-4.583,16.999-11.56l56.569-143.137 C1685.568,1121.795,1679.473,1112.833,1670.58,1112.833z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041997606235889352930000000938958462605954732_",
    gradientUnits: "userSpaceOnUse",
    x1: -4806.4248,
    y1: 1164.407,
    x2: -4855.5737,
    y2: 1238.4194,
    gradientTransform: "matrix(-1 0 0 1 -3256.1277 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041997606235889352930000000938958462605954732_)"
    },
    d: "M1559.411,1192.144 c-3.419,10.624-0.893,20.941,5.643,23.045c6.536,2.104,14.606-4.803,18.025-15.427c3.42-10.623,0.894-20.941-5.642-23.045 C1570.901,1174.613,1562.831,1181.52,1559.411,1192.144z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026131548463778597510000014101710005834326459_",
    gradientUnits: "userSpaceOnUse",
    x1: 1178.9368,
    y1: 1840.0385,
    x2: 1204.7821,
    y2: 2447.4163
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026131548463778597510000014101710005834326459_)"
    },
    d: "M557.688,3151.499 c0,12.862,10.534,23.385,23.408,23.385h1265.812c12.874,0,23.408-10.523,23.408-23.385l10.533-727.427 c0-12.862-15.154-37.972-42.925-36.085l-1237.091-32.01c-16.154-0.418-31.772,5.799-43.211,17.201 c-11.439,11.402-17.698,26.991-17.316,43.13L557.688,3151.499z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028289150149706075040000012937377469934154640_",
    gradientUnits: "userSpaceOnUse",
    x1: 1200.7063,
    y1: 3119.1882,
    x2: 1194.2274,
    y2: 1946.3273
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028289150149706075040000012937377469934154640_)"
    },
    d: "M460.654,3235.27h1481.035 c3.109,0,5.654-2.544,5.654-5.654v-52.607c0-3.11-2.544-5.654-5.654-5.654H460.654c-3.109,0-5.654,2.544-5.654,5.654v52.607 C455,3232.726,457.544,3235.27,460.654,3235.27z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155120155860259075330000011314635209622068153_",
    gradientUnits: "userSpaceOnUse",
    x1: 1284.9139,
    y1: 2484.8064,
    x2: 974.8037,
    y2: 3557.887
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155120155860259075330000011314635209622068153_)"
    },
    d: "M580.798,3129.064 c0,12.18,9.966,22.145,22.146,22.145h1213.439c12.18,0,22.146-9.966,22.146-22.145l9.939-660.365 c-1.171-39.739-36.011-54.022-57.13-53.178l-1185.639-31.809c-11.349-0.304-22.321,4.068-30.359,12.085 c-8.038,8.017-12.458,18.99-12.174,30.339L580.798,3129.064z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1674.4445 1651.6432)",
    style: {
      opacity: 0.32,
      fill: "#FFFFFF"
    },
    cx: 1156.487,
    cy: 2847.055,
    rx: 215.407,
    ry: 215.407
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010308010587455942940000004455956888217576078_",
    gradientUnits: "userSpaceOnUse",
    x1: 1045.6528,
    y1: 2850.7507,
    x2: 1278.609,
    y2: 2850.7507
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010308010587455942940000004455956888217576078_)"
    },
    d: "M1154.466,2974.709 c-9.434,0-18.208-5.004-23.089-13.233l-81.873-138.025c-7.663-12.918-3.534-29.679,9.22-37.439 c12.749-7.758,29.301-3.581,36.964,9.337l56.834,95.814l75.132-149.46c6.75-13.429,22.974-18.772,36.23-11.935 c13.259,6.837,18.536,23.266,11.786,36.693l-97.193,193.344c-4.444,8.84-13.278,14.542-23.064,14.888 C1155.098,2974.703,1154.782,2974.709,1154.466,2974.709z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022526533977381776810000003366887839149140114_",
    gradientUnits: "userSpaceOnUse",
    x1: 2259.2683,
    y1: 2888.2446,
    x2: 2846.0593,
    y2: 2888.2446,
    gradientTransform: "matrix(0.9998 -0.0219 0.0219 0.9998 28.2232 -27.654)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022526533977381776810000003366887839149140114_)"
    },
    d: "M2392.654,2373.059 c-22.751,1.979-40.195,21.033-40.259,43.87c-0.396,139.658-1.05,621.377,8.053,791.879 c0.964,18.063,15.773,32.253,33.861,32.448c89.463,0.963,346.8,2.732,492.891-6.612c30.428-1.947,54.107-27.148,54.07-57.639 c-0.177-146.576-2.519-558.8-22.598-747.222c-2.406-22.576-20.553-40.198-43.188-41.961 C2777.91,2380.219,2518.804,2362.088,2392.654,2373.059z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160908763163356034680000014294564999915118217_",
    gradientUnits: "userSpaceOnUse",
    x1: 2401.4092,
    y1: 2492.4487,
    x2: 3636.019,
    y2: 4224.3691,
    gradientTransform: "matrix(1 -0.0042 0.0042 1 5.3179 -4.8586)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6645,
    style: {
      stopColor: "#E57A58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160908763163356034680000014294564999915118217_)"
    },
    d: "M2388.306,2453.529 c-1.757,119.465-6.759,516.877,1.973,663.554c1.276,21.439,17.93,38.365,38.493,39.082c84.664,2.95,301.77,8.66,425.481-4.952 c22.276-2.451,39.302-21.76,39.895-45.14c3.094-121.914,11.453-492.057,2.967-637.094c-1.354-23.137-19.031-41.6-41.189-43.093 c-91.671-6.177-327.071-20.422-432.27-11.661C2403.907,2415.869,2388.611,2432.847,2388.306,2453.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F5AA9"
    },
    d: "M2592.864,2393.831c0.072,3.301,2.704,5.966,6.004,6.066c16.291,0.495,62.182,1.9,82.694,2.639 c4.044,0.146,7.135-3.555,6.281-7.511c-0.07-0.125-0.596-5.197-5.776-5.557c-13.875-0.965-55.736-3.566-83.399-1.97 C2592.989,2387.826,2592.68,2394.286,2592.864,2393.831z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1195.9669 2690.3301)",
    style: {
      opacity: 0.32,
      fill: "#FFFFFF"
    },
    cx: 2649.532,
    cy: 2788.825,
    rx: 138.669,
    ry: 138.669
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083080260939965076480000000451396006191310239_",
    gradientUnits: "userSpaceOnUse",
    x1: 2578.1821,
    y1: 2791.2041,
    x2: 2728.1484,
    y2: 2791.2041
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083080260939965076480000000451396006191310239_)"
    },
    d: "M2648.231,2871.003 c-6.073,0-11.721-3.222-14.864-8.519l-52.706-88.854c-4.933-8.316-2.275-19.106,5.936-24.101 c8.207-4.994,18.863-2.305,23.796,6.01l36.587,61.68l48.366-96.215c4.345-8.645,14.79-12.084,23.323-7.683 c8.536,4.401,11.933,14.977,7.587,23.621l-62.568,124.466c-2.861,5.691-8.548,9.361-14.848,9.584 C2648.638,2870.999,2648.435,2871.003,2648.231,2871.003z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2621.554,2308.931c-0.068,0-0.137,0-0.206-0.001c-5.597-0.112-10.046-4.741-9.934-10.34 c0.112-5.597,4.7-10.254,10.343-10.099c5.598,0.112,10.05,4.576,9.938,10.175l-0.007,0.33 C2631.577,2304.524,2627.059,2308.931,2621.554,2308.931z M2622.217,2278.192c-0.074,0-0.148,0-0.223-0.001 c-5.597-0.121-10.038-4.758-9.919-10.355l0.654-30.41c0.121-5.597,4.758-10,10.355-9.919c5.597,0.12,10.04,4.757,9.919,10.355 l-0.653,30.41C2632.23,2273.794,2627.714,2278.192,2622.217,2278.192z M2623.524,2217.372c-0.074,0-0.149,0-0.223-0.002 c-5.597-0.121-10.038-4.758-9.919-10.355l0.653-30.408c0.121-5.599,4.814-10.093,10.355-9.919 c5.597,0.12,10.038,4.758,9.919,10.355l-0.654,30.408C2633.537,2212.974,2629.021,2217.372,2623.524,2217.372z M2624.833,2156.554 c-0.074,0-0.149,0-0.223-0.001c-5.597-0.121-10.04-4.758-9.919-10.355l0.653-30.41c0.121-5.598,4.743-10.06,10.355-9.919 c5.597,0.12,10.038,4.758,9.919,10.355l-0.654,30.41C2634.846,2152.156,2630.33,2156.554,2624.833,2156.554z M2626.14,2095.735 c-0.074,0-0.148,0-0.223-0.002c-5.599-0.12-10.04-4.758-9.919-10.355l0.655-30.408c0.122-5.599,4.795-10.028,10.355-9.919 c5.599,0.12,10.04,4.758,9.919,10.355l-0.655,30.408C2636.151,2091.339,2631.636,2095.735,2626.14,2095.735z M2627.448,2034.917 c-0.074,0-0.148,0-0.223-0.002c-5.597-0.12-10.038-4.757-9.919-10.355l0.654-30.41c0.12-5.597,4.85-9.994,10.355-9.919 c5.597,0.12,10.038,4.757,9.919,10.355l-0.654,30.41C2637.462,2030.519,2632.945,2034.917,2627.448,2034.917z M2628.757,1974.098 c-0.074,0-0.148,0-0.223-0.002c-5.597-0.12-10.04-4.758-9.919-10.355l0.654-30.408c0.12-5.597,4.781-10.086,10.355-9.919 c5.597,0.12,10.038,4.758,9.919,10.355l-0.654,30.408C2638.77,1969.7,2634.254,1974.098,2628.757,1974.098z M2630.064,1913.28 c-0.074,0-0.148,0-0.223-0.002c-5.598-0.12-10.038-4.757-9.919-10.355l0.654-30.41c0.12-5.597,4.835-10.053,10.355-9.919 c5.597,0.12,10.04,4.758,9.919,10.355l-0.653,30.41C2640.077,1908.882,2635.561,1913.28,2630.064,1913.28z M2631.372,1852.46 c-0.074,0-0.148,0-0.223-0.002c-5.598-0.12-10.038-4.758-9.919-10.355l0.654-30.408c0.12-5.598,4.764-10.022,10.355-9.919 c5.597,0.12,10.038,4.757,9.919,10.355l-0.653,30.408C2641.386,1848.062,2636.869,1852.46,2631.372,1852.46z M2632.679,1791.642 c-0.074,0-0.148,0-0.223-0.002c-5.599-0.12-10.04-4.758-9.919-10.355l0.655-30.41c0.122-5.601,4.817-9.989,10.355-9.919 c5.599,0.12,10.04,4.758,9.919,10.355l-0.655,30.41C2642.691,1787.246,2638.176,1791.642,2632.679,1791.642z M2633.988,1730.824 c-0.074,0-0.148,0-0.223-0.002c-5.597-0.12-10.038-4.758-9.919-10.355l0.654-30.41c0.121-5.597,4.749-10.081,10.355-9.919 c5.597,0.12,10.04,4.758,9.919,10.355l-0.654,30.41C2644.001,1726.427,2639.485,1730.824,2633.988,1730.824z M2624.757,1679.97 c-0.119,0-0.236-0.002-0.356-0.007l-30.398-1.048c-5.596-0.193-9.976-4.885-9.782-10.482c0.191-5.598,4.792-10.004,10.482-9.782 l30.398,1.048c5.596,0.193,9.975,4.885,9.782,10.482C2634.694,1675.658,2630.194,1679.97,2624.757,1679.97z M2563.96,1677.875 c-0.119,0-0.236-0.002-0.356-0.007l-30.398-1.048c-5.596-0.193-9.976-4.885-9.782-10.482c0.191-5.596,4.856-10.069,10.482-9.782 l30.398,1.048c5.596,0.193,9.975,4.884,9.782,10.482C2573.898,1673.563,2569.398,1677.875,2563.96,1677.875z M2503.164,1675.779 c-0.119,0-0.238-0.002-0.356-0.007l-30.398-1.05c-5.596-0.193-9.975-4.886-9.782-10.482c0.191-5.596,4.919-10.055,10.482-9.782 l30.398,1.05c5.596,0.193,9.976,4.886,9.782,10.482C2513.101,1671.467,2508.601,1675.779,2503.164,1675.779z M2442.367,1673.682 c-0.119,0-0.236-0.002-0.355-0.007l-3.309-0.114c-5.541-0.19-9.901-4.795-9.789-10.338l0.553-27.1 c0.115-5.599,4.759-10.008,10.343-9.931c5.599,0.114,10.045,4.746,9.931,10.343l-0.401,19.654c2.03,1.927,3.256,4.683,3.152,7.701 C2452.305,1669.368,2447.805,1673.682,2442.367,1673.682z M2440.23,1616.057c-0.071,0-0.14,0-0.211-0.002 c-5.599-0.114-10.045-4.746-9.931-10.343l0.621-30.41c0.115-5.599,4.813-9.969,10.343-9.931 c5.599,0.114,10.045,4.746,9.931,10.343l-0.62,30.41C2450.249,1611.652,2445.732,1616.057,2440.23,1616.057z M2441.471,1555.237 c-0.071,0-0.14,0-0.211-0.002c-5.599-0.114-10.045-4.746-9.931-10.343l0.621-30.41c0.117-5.599,4.868-10.061,10.343-9.931 c5.599,0.114,10.045,4.746,9.931,10.343l-0.62,30.41C2451.49,1550.833,2446.973,1555.237,2441.471,1555.237z M2442.714,1494.418 c-0.071,0-0.14,0-0.211-0.002c-5.599-0.114-10.045-4.746-9.931-10.343l0.62-30.41c0.116-5.599,4.792-10.021,10.344-9.931 c5.599,0.114,10.045,4.746,9.931,10.343l-0.621,30.41C2452.732,1490.013,2448.216,1494.418,2442.714,1494.418z M2443.955,1433.597 c-0.071,0-0.14,0-0.211-0.002c-5.599-0.114-10.045-4.746-9.931-10.343l0.62-30.41c0.115-5.599,4.848-9.982,10.344-9.931 c5.599,0.114,10.045,4.746,9.931,10.343l-0.621,30.41C2453.973,1429.192,2449.457,1433.597,2443.955,1433.597z M2445.196,1372.777 c-0.071,0-0.14,0-0.211-0.002c-5.599-0.114-10.045-4.746-9.931-10.343l0.62-30.41c0.115-5.598,4.807-9.999,10.344-9.931 c5.599,0.114,10.045,4.746,9.931,10.343l-0.62,30.41C2455.214,1368.373,2450.698,1372.777,2445.196,1372.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1806.415,2320.914c-0.056,0-0.112,0-0.17-0.002c-5.599-0.092-10.063-4.705-9.971-10.304 l0.5-30.413c0.092-5.597,4.621-10.101,10.304-9.97c5.599,0.092,10.063,4.705,9.97,10.304l-0.5,30.413 C1816.458,2316.483,1811.936,2320.914,1806.415,2320.914z M1807.415,2260.089c-0.056,0-0.112,0-0.17-0.002 c-5.599-0.092-10.063-4.705-9.971-10.304l0.5-30.413c0.092-5.597,4.604-10.139,10.304-9.97c5.599,0.092,10.063,4.705,9.97,10.304 l-0.5,30.413C1817.458,2255.658,1812.936,2260.089,1807.415,2260.089z M1808.415,2199.265c-0.056,0-0.112,0-0.17-0.002 c-5.599-0.092-10.063-4.705-9.971-10.304l0.5-30.413c0.092-5.597,4.588-10.177,10.304-9.97c5.599,0.093,10.063,4.705,9.97,10.304 l-0.5,30.413C1818.458,2194.834,1813.936,2199.265,1808.415,2199.265z M1809.416,2138.44c-0.056,0-0.112,0-0.17-0.002 c-5.599-0.092-10.063-4.705-9.971-10.304l0.5-30.413c0.092-5.597,4.571-10.05,10.304-9.97c5.599,0.092,10.063,4.705,9.97,10.304 l-0.5,30.413C1819.459,2134.01,1814.938,2138.44,1809.416,2138.44z M1810.416,2077.614c-0.058,0-0.112,0-0.17-0.002 c-5.599-0.092-10.063-4.705-9.971-10.304l0.5-30.411c0.092-5.597,4.555-10.088,10.304-9.97c5.599,0.092,10.063,4.705,9.97,10.304 l-0.5,30.412C1820.459,2073.183,1815.938,2077.614,1810.416,2077.614z M1811.416,2016.79c-0.056,0-0.112,0-0.17-0.002 c-5.599-0.092-10.063-4.705-9.971-10.304l0.5-30.411c0.091-5.541,4.612-9.972,10.134-9.972c0.056,0,0.112,0,0.17,0.002 c5.599,0.092,10.063,4.705,9.97,10.304l-0.5,30.411C1821.459,2012.359,1816.938,2016.79,1811.416,2016.79z M1812.416,1955.965 c-0.056,0-0.114,0-0.17-0.002c-5.599-0.092-10.063-4.706-9.97-10.304l0.502-30.411c0.092-5.599,4.687-10.163,10.304-9.97 c5.599,0.092,10.063,4.706,9.97,10.304l-0.502,30.411C1822.459,1951.536,1817.938,1955.965,1812.416,1955.965z M1813.418,1895.141 c-0.058,0-0.112,0-0.17-0.002c-5.599-0.092-10.063-4.705-9.971-10.304l0.5-30.411c0.091-5.541,4.612-9.972,10.134-9.972 c0.056,0,0.112,0,0.17,0.002c5.599,0.092,10.063,4.705,9.97,10.304l-0.5,30.411 C1823.461,1890.71,1818.939,1895.141,1813.418,1895.141z M1814.418,1834.316c-0.056,0-0.112,0-0.17-0.002 c-5.599-0.092-10.063-4.705-9.971-10.304l0.5-30.411c0.091-5.597,4.655-10.074,10.304-9.97c5.599,0.092,10.063,4.705,9.97,10.304 l-0.5,30.411C1824.461,1829.885,1819.939,1834.316,1814.418,1834.316z M1815.418,1773.492c-0.056,0-0.112,0-0.17-0.002 c-5.599-0.092-10.063-4.705-9.97-10.304l0.5-30.411c0.091-5.597,4.639-10.112,10.304-9.97c5.599,0.092,10.063,4.705,9.97,10.304 l-0.5,30.411C1825.461,1769.061,1820.939,1773.492,1815.418,1773.492z M1816.418,1712.667c-0.056,0-0.114,0-0.17-0.002 c-5.599-0.092-10.063-4.706-9.97-10.304l0.502-30.411c0.091-5.599,4.786-10.149,10.304-9.97c5.599,0.092,10.063,4.706,9.97,10.304 l-0.502,30.411C1826.461,1708.236,1821.94,1712.667,1816.418,1712.667z M1829.918,1664.394c-5.541,0-10.066-4.455-10.137-10.01 c-0.069-5.599,4.411-10.197,10.01-10.268l30.415-0.384c5.535,0.013,10.196,4.411,10.267,10.01 c0.069,5.599-4.411,10.197-10.01,10.267l-30.415,0.385C1830.004,1664.394,1829.961,1664.394,1829.918,1664.394z  M1890.746,1663.625c-5.541,0-10.066-4.456-10.135-10.01c-0.071-5.599,4.409-10.197,10.008-10.268l30.415-0.384 c5.513-0.045,10.197,4.411,10.268,10.01c0.069,5.599-4.411,10.197-10.01,10.268l-30.415,0.385 C1890.832,1663.625,1890.789,1663.625,1890.746,1663.625z M1951.572,1662.855c-5.54,0-10.065-4.456-10.134-10.012 c-0.071-5.599,4.411-10.195,10.01-10.264l5.33-0.068l0.086-5.378c0.087-5.597,4.588-10.124,10.299-9.975 c5.599,0.089,10.065,4.7,9.975,10.299l-0.243,15.23c-0.088,5.485-4.523,9.908-10.01,9.977l-15.183,0.191 C1951.66,1662.855,1951.617,1662.855,1951.572,1662.855z M1967.487,1617.021c-0.054,0-0.109,0-0.165-0.002 c-5.598-0.089-10.065-4.7-9.976-10.299l0.484-30.413c0.089-5.597,4.546-10.03,10.299-9.975c5.597,0.089,10.064,4.7,9.975,10.299 l-0.484,30.413C1977.533,1612.586,1973.011,1617.021,1967.487,1617.021z M1968.452,1556.196c-0.054,0-0.109,0-0.165-0.002 c-5.597-0.089-10.064-4.7-9.975-10.299l0.484-30.413c0.089-5.598,4.596-10.071,10.299-9.976c5.597,0.089,10.065,4.7,9.975,10.299 l-0.484,30.413C1978.498,1551.762,1973.977,1556.196,1968.452,1556.196z M1969.417,1495.37c-0.055,0-0.109,0-0.165-0.002 c-5.598-0.089-10.065-4.7-9.975-10.299l0.484-30.411c0.087-5.543,4.611-9.977,10.134-9.977c0.055,0,0.109,0,0.165,0.002 c5.598,0.089,10.065,4.7,9.975,10.299l-0.483,30.411C1979.464,1490.936,1974.942,1495.37,1969.417,1495.37z M1970.383,1434.546 c-0.054,0-0.109,0-0.165-0.002c-5.597-0.089-10.065-4.7-9.975-10.299l0.484-30.413c0.088-5.543,4.609-9.977,10.134-9.977 c0.054,0,0.109,0,0.165,0.002c5.597,0.089,10.064,4.7,9.975,10.299l-0.484,30.413 C1980.429,1430.111,1975.907,1434.546,1970.383,1434.546z M1971.348,1373.721c-0.054,0-0.109,0-0.165-0.002 c-5.599-0.089-10.064-4.7-9.975-10.299l0.483-30.413c0.088-5.543,4.609-9.977,10.134-9.977c0.054,0,0.109,0,0.165,0.002 c5.599,0.089,10.064,4.7,9.975,10.299l-0.484,30.413C1981.394,1369.287,1976.873,1373.721,1971.348,1373.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2177.696,1952.947c-0.011,0-0.025,0-0.036,0c-5.601-0.02-10.122-4.576-10.103-10.177l0.033-9.013 c0.02-5.588,4.556-10.103,10.139-10.103c0.011,0,0.025,0,0.038,0c5.599,0.02,10.121,4.576,10.101,10.175l-0.033,9.015 C2187.815,1948.432,2183.279,1952.947,2177.696,1952.947z M2177.84,1913.516c-0.012,0-0.025,0-0.038,0 c-5.599-0.021-10.121-4.576-10.101-10.177l0.112-30.416c0.021-5.586,4.556-10.101,10.139-10.101c0.011,0,0.025,0,0.038,0 c5.599,0.021,10.122,4.576,10.101,10.177l-0.112,30.416C2187.957,1909.001,2183.423,1913.516,2177.84,1913.516z  M2178.064,1852.683c-0.013,0-0.026,0-0.038,0c-5.601-0.02-10.122-4.576-10.102-10.175l0.11-30.416 c0.02-5.588,4.556-10.102,10.139-10.102c0.011,0,0.025,0,0.036,0c5.601,0.02,10.122,4.576,10.102,10.175l-0.111,30.417 C2188.182,1848.168,2183.645,1852.683,2178.064,1852.683z M2178.285,1791.85c-0.013,0-0.026,0-0.04,0 c-5.599-0.021-10.121-4.576-10.101-10.177l0.112-30.416c0.021-5.586,4.556-10.101,10.137-10.101c0.013,0,0.027,0,0.04,0 c5.599,0.021,10.121,4.576,10.101,10.177l-0.112,30.416C2188.401,1787.335,2183.866,1791.85,2178.285,1791.85z M2178.508,1731.017 c-0.013,0-0.026,0-0.038,0c-5.601-0.02-10.122-4.576-10.102-10.175l0.111-30.415c0.02-5.588,4.556-10.103,10.139-10.103 c0.012,0,0.025,0,0.036,0c5.601,0.02,10.122,4.576,10.103,10.175l-0.111,30.415 C2188.625,1726.502,2184.089,1731.017,2178.508,1731.017z M2178.731,1670.186c-0.013,0-0.027,0-0.038,0 c-5.601-0.02-10.122-4.576-10.103-10.175l0.111-30.416c0.02-5.588,4.556-10.102,10.139-10.102c0.011,0,0.025,0,0.036,0 c5.601,0.02,10.122,4.576,10.103,10.175l-0.111,30.416C2188.848,1665.672,2184.312,1670.186,2178.731,1670.186z  M2178.952,1609.354c-0.013,0-0.026,0-0.04,0c-5.599-0.022-10.121-4.576-10.101-10.177l0.112-30.416 c0.021-5.586,4.556-10.101,10.139-10.101c0.011,0,0.025,0,0.038,0c5.599,0.021,10.121,4.576,10.101,10.177l-0.112,30.416 C2189.068,1604.839,2184.533,1609.354,2178.952,1609.354z M2179.175,1548.521c-0.013,0-0.026,0-0.038,0 c-5.601-0.02-10.122-4.576-10.103-10.175l0.111-30.417c0.02-5.599,4.551-10.211,10.175-10.102 c5.601,0.02,10.122,4.576,10.102,10.175l-0.111,30.416C2189.292,1544.006,2184.756,1548.521,2179.175,1548.521z  M2179.396,1487.688c-0.013,0-0.026,0-0.04,0c-5.599-0.022-10.121-4.576-10.101-10.177l0.112-30.415 c0.021-5.586,4.556-10.101,10.139-10.101c0.012,0,0.025,0,0.038,0c5.599,0.021,10.121,4.576,10.101,10.177l-0.112,30.415 C2189.512,1483.173,2184.977,1487.688,2179.396,1487.688z M2179.619,1426.857c-0.013,0-0.026,0-0.038,0 c-5.601-0.02-10.122-4.576-10.102-10.175l0.111-30.416c0.02-5.588,4.556-10.102,10.139-10.102c0.011,0,0.025,0,0.036,0 c5.601,0.02,10.122,4.576,10.103,10.175l-0.111,30.416C2189.736,1422.342,2185.2,1426.857,2179.619,1426.857z M2179.842,1366.025 c-0.013,0-0.026,0-0.038,0c-5.601-0.02-10.122-4.576-10.103-10.175l0.111-30.416c0.02-5.588,4.556-10.102,10.139-10.102 c0.011,0,0.025,0,0.036,0c5.601,0.02,10.122,4.576,10.103,10.175l-0.111,30.416 C2189.959,1361.51,2185.423,1366.025,2179.842,1366.025z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFragments);
export default __webpack_public_path__ + "static/media/fragments.706ceb6e61daee2458b488a462e0e774.svg";
export { ForwardRef as ReactComponent };